module.exports = __webpack_public_path__ + "static/media/fontanelles_horizontal.a21de793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fontanelles_horizontal.png
// module id = 1761
// module chunks = 0